import { render, staticRenderFns } from "./goods-report.vue?vue&type=template&id=40279a64&scoped=true"
import script from "./goods-report.vue?vue&type=script&lang=js"
export * from "./goods-report.vue?vue&type=script&lang=js"
import style0 from "./goods-report.vue?vue&type=style&index=0&id=40279a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40279a64",
  null
  
)

export default component.exports